export default {"src":"/_next/static/media/payment-success.57091817.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};